var React = require('react');

function OpensquareFooterLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M47.8582 24L39.1972 19L49.5904 13L63.8811 21.25V26.75L49.5904 35L39.1972 29L47.8582 24Z","fill":"white","key":0}),React.createElement("path",{"d":"M28.804 29L20.143 24L28.804 19L18.4108 13L4.12012 21.25V26.75L18.4108 35L28.804 29Z","fill":"white","key":1}),React.createElement("path",{"d":"M34.0006 34L42.6616 39L34.0006 44L25.3396 39L34.0006 34Z","fill":"white","key":2}),React.createElement("path",{"d":"M42.6616 9L34.0006 4L25.3396 9L34.0006 14L42.6616 9Z","fill":"white","key":3})]);
}

OpensquareFooterLogo.defaultProps = {"width":"68","height":"48","viewBox":"0 0 68 48","fill":"none"};

module.exports = OpensquareFooterLogo;

OpensquareFooterLogo.default = OpensquareFooterLogo;
